// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"5265":"css/app.6750","7160":"css/admin-app.6750"}[chunkId] + ".css";
};